(function(){

  const bindings = new WeakMap();

  function bind(element) {
    if (bindings.has(element)) return;
    bindings.set(element, new DeallocInject(element));
  }

  class DeallocInject {
    element = undefined
    mode = undefined
    selector = undefined

    constructor(element) {
      this.element = element;
      this.mode = this._getMode();
      this.selector = this._getSelector(this.mode);

      const existingTarget = this._getTarget();

      console.info('[dealloc-inject] construct');

      if (existingTarget) {
        this._perform(existingTarget);
      } else if (this.isAsync) {
        this.startAsyncObserver();
      } else {
        console.warn('[dealloc-inject] unhandled injection');
      }
    }

    get isAsync() {
      return this.element.hasAttribute('data-async');
    }

    _asyncObserver;

    startAsyncObserver() {
      if (this._asyncObserver) {
        return;
      }

      console.info('[dealloc-inject] async injection');

      const observer = new MutationObserver(this._bodyMutationCallback.bind(this));
      this._asyncObserver = observer;
      
      observer.observe(document.body, { subtree: true, childList: true });
      
    }

    _stopAsyncObserver() {
      if (this._asyncObserver) {
        this._asyncObserver.disconnect();
        this._asyncObserver = undefined;
      }
    }

    _bodyMutationCallback(mutations) {
      for(const mutation of mutations) {
        if (mutation.type == 'childList' && mutation.addedNodes.length > 0) {
          this._processAddedNodes(mutation.addedNodes);
        }
      }
    }

    _processAddedNodes(nodes) {
      for (const node of Array.from(nodes)) {
        if (node.nodeType != Node.ELEMENT_NODE) {
          continue;
        }

        const element = node;

        if (element.matches(this.selector)) {
          window.requestAnimationFrame(() => this._perform(element));
          break;
        }

        const subtreeMatch = element.querySelector(this.selector);
        if (subtreeMatch) {
          window.requestAnimationFrame(() => this._perform(subtreeMatch));
          break;
        }
      }
    }

    _getTarget() {
      return document.querySelector(this.selector);
    }

    _getMode() {
      if (this.isAppend) {
        return 'append';
      } else if (this.isInjectBefore) {
        return 'before';
      } else if (this.isInjectAfter) {
        return 'after';
      } else {
        return null;
      }
    }
    
    _getSelector(mode) {
      switch(mode) {
        case 'append': {
          return this.appendSelector;
        }
        case 'before': {
          return this.beforeSelector;
        }
        case 'after': {
          return this.afterSelector;
        }
        default: {
          return null;
        }
      }
    }

    _performed = false;

    _perform(target) {
      if (this._performed == true) {
        return;
      }

      this._stopAsyncObserver();

      const { mode } = this;

      const content = this.element.content.cloneNode(true);
      console.info(`[dealloc-inject] perform ${mode}`);

      switch(mode) {
        case 'append': {
          target.appendChild(content);
          break;
        }
        case 'before': {
          const parent = target.parentElement;
          parent.insertBefore(content, target);
          break;
        }
        case 'after': {
          const parent = target.parentElement;
          const sibling = target.nextSibling;
          if (sibling) {
            parent.insertBefore(content, sibling);
          } else {
            parent.appendChild(content);
          }
          break;
        }
      }

      this._performed = true;
    }

    get isAppend() {
      return this.element.hasAttribute('data-append');
    }
    
    get isInjectBefore() {
      return this.element.hasAttribute('data-before');
    }
    
    get isInjectAfter() {
      return this.element.hasAttribute('data-after');
    }

    get appendSelector() {
      return this.element.getAttribute('data-append');
    }

    get beforeSelector() {
      return this.element.getAttribute('data-before');
    }
    
    get afterSelector() {
      return this.element.getAttribute('data-after');
    }

  }

  document.querySelectorAll('template[data-dealloc="inject"]').forEach(bind);

})();